/* eslint-disable linebreak-style */
const blogDataEn = [
  {
    id: 1,
    title: "Bulindo Agro Tech: The Best Solution for Quality Fertilizer",
    excerpt: "Bulindo Agro Tech is a leading company engaged in the sale of fertilizer for all types of plants.",
    content: `
      <p>Bulindo Agro Tech is a leading company engaged in the sale of fertilizer for all types of plants. With a high commitment to quality and sustainability, Bulindo Agro Tech has become a trusted partner for farmers, gardeners, and plant enthusiasts throughout Indonesia.</p>
      
      <h3>Why Choose Bulindo Agro Tech?</h3>
      <p>1. High Quality Fertilizer Bulindo Agro Tech offers various types of fertilizer specifically designed to meet the nutritional needs of your plants. Our products ensure plants grow lush, healthy, and productive.</p>
      <p>2. Suitable for All Types of Plants Whether you grow rice, vegetables, fruits, or ornamental plants, Bulindo Agro Tech has the right fertilizer solution for you. We provide organic fertilizer, inorganic fertilizer, and liquid fertilizer that are easy to apply.</p>
      <p>3. Increase Harvest Yield With a proven formula, fertilizer from Bulindo Agro Tech helps increase harvest yield both in terms of quantity and quality. Plants become more resistant to pests and diseases.</p> 
      <p>4. Professional Service Our team is ready to provide consultation and recommendations for the best products according to your plant type and land conditions.</p>
      
      <h3>Types of Fertilizer Available at Bulindo Agro Tech</h3>
      <p>Organic Fertilizer: Environmentally friendly and improves soil structure.</p>
      <p>NPK Fertilizer: Optimizes plant growth with a combination of nitrogen, phosphorus, and potassium.</p>
      <p>Liquid Fertilizer: Easily absorbed by plants, suitable for fast application.</p>
      <p>Micro Fertilizer: Meets micro nutrient needs that are important for plants.</p>
      
      <h3>How to Get Bulindo Agro Tech Products</h3>
      <p>You can easily get our products through official distributors, agricultural stores, or order directly 
      through the official Bulindo Agro Tech website. With an extensive distribution network, we ensure products reach your hands quickly and safely.</p>
      
      <h3>Customer Testimonials</h3>
      <p>Here are some testimonials from our customers:</p>
      <p>1. "Since using Bulindo fertilizer, my harvest has increased drastically. Vegetables are fresher and healthier!"</p>
      <p>2. "Liquid fertilizer from Bulindo is very easy to use and the results are visible in a short time."</p>
      <p>3. "My ornamental plants have become more lush and bloom profusely. Very satisfied with the quality of this fertilizer."</p>

      <h3>Bulindo Agro Tech's Commitment</h3>
      <p>Bulindo Agro Tech is committed to supporting sustainable agriculture in Indonesia. With the latest innovations and technology, we continue to strive 
      to provide the best solutions for farmers and plant enthusiasts.</p>
      `,
    author: "Admin",
    publishedDate: "2024-12-30",
    category: "Bulindo Agro Technology",
    image: "/assets/images/logo-small-black.png",
    tags: ["Agriculture", "Company"],
    readTime: "8 minutes",
  },
  {
    id: 2,
    title: "The Importance of Fertilizer for Plants: Key to Growth and Productivity",
    excerpt: "Fertilizer is an important element in the world of agriculture and gardening. Without fertilizer, plants are difficult to grow.",
    content: `
    <p>Fertilizer is an important element in the world of agriculture and gardening. Without fertilizer, plants are difficult to grow optimally 
    and produce quality harvests. Fertilizer provides essential nutrients that plants need to develop 
    well, thus becoming the main solution to increase productivity and quality of agricultural products.</p>
    
    <h3>Why is Fertilizer Important for Plants?</h3>

    <p>1. Provides Essential Nutrients Plants need various nutrients to grow, such as nitrogen (N), phosphorus (P), 
    and potassium (K). Fertilizer provides these nutrients in the right amount to support plant growth.</p>
    <p>2. Increases Soil Fertility The use of fertilizer, especially organic fertilizer, helps improve soil structure and 
    increases the soil's ability to retain water and nutrients. Fertile soil is the main key to healthy plant growth.</p>
    <p>3. Increases Harvest Yield With sufficient nutrient intake, plants can produce more and quality harvests. Fertilizer 
    ensures plants grow optimally, from roots to fruit.</p>
    <p>4. Increases Plant Resistance Plants that are given fertilizer have better resistance to pests, diseases, and extreme 
    weather changes. This helps farmers reduce losses due to external factors.</p>
    
    <h3>Types of Fertilizer Commonly Used</h3>
    <p>1. Organic Fertilizer Made from natural materials such as compost, animal manure, or plant residues. This fertilizer is environmentally friendly and improves 
    soil structure naturally.</p>
    <p>2. Inorganic Fertilizer Produced chemically and contains certain nutrients in high concentrations. Examples are NPK fertilizer, urea, 
    and TSP.</p>
    <p>3. Liquid Fertilizer Easy to apply and quickly absorbed by plants. Liquid fertilizer is suitable for ornamental plants, vegetables, and fruit plants.</p>
    <p>4. Micro Fertilizer Contains micro nutrients such as magnesium, zinc, and iron that are important for plant physiological processes.</p>
    
    <h3>How to Use Fertilizer Correctly</h3>
    <p>1. Know Plant Needs Each type of plant has different nutritional needs. Make sure you use fertilizer that suits 
    the type of plant you grow.</p>
    <p>2. Follow Recommended Doses Excessive use of fertilizer can damage plants and pollute the environment. Always follow the dose instructions 
    listed on the fertilizer package.</p>
    <p>3. Apply at the Right Time Fertilizer should be given in the morning or afternoon to avoid evaporation. In addition, apply 
    fertilizer according to the plant growth phase, such as vegetative or generative periods.</p>
    <p>4. Use Fertilizer Combinations Combine organic and inorganic fertilizer for optimal results. Organic fertilizer helps improve soil, 
    while inorganic fertilizer provides direct nutrients.</p>

    <h3>Positive Impacts of Fertilizer Use</h3>
    <p>Fast Growth: Plants grow faster and healthier.</p>
    <p>Abundant Harvest: Production increases both in terms of quantity and quality.</p>
    <p>Agricultural Sustainability: Organic fertilizer helps maintain soil ecosystem balance.</p>
    
    <h3>Conclusion</h3>
    <p>Fertilizer is the main key to supporting plant growth and increasing harvest yield. With proper use, fertilizer not only helps 
    plants grow lush but also maintains agricultural sustainability. Choose fertilizer that suits your plant's needs and apply wisely for best results.</p>
    `,
    author: "Admin",
    publishedDate: "2024-12-30",
    category: "Fertilizer",
    image: "/assets/images/pupuk.jpg",
    tags: ["Agriculture", "Fertilizer"],
    readTime: "9 minutes",
  },
  {
    id: 3,
    title: "Natural Bio Stimulant: Organic Plant Growth Revolution",
    excerpt: "Bio stimulant products from seaweed extract and humic acid proven to increase plant vigor, stress resistance, and harvest quality naturally.",
    content: `
      <p>Natural bio stimulants represent a new generation in plant nutrition that focuses on improving plant physiological functions naturally. Our bio stimulant products use natural active ingredients that work synergistically with plant metabolism.</p>
      
      <h3>1. Premium Seaweed Extract</h3>
      <p>Uses Ascophyllum nodosum extract from North Atlantic waters rich in natural phytohormones (auxin, cytokinin, gibberellin), betaine, mannitol, and complex polysaccharides that increase stress tolerance and plant vigor.</p>
      
      <h3>2. Humic and Fulvic Acid</h3>
      <p>Contains 15% humic acid and 8% fulvic acid from high-quality leonardite that functions as a natural chelating agent, increases soil cation exchange capacity, and improves soil structure sustainably.</p>
      
      <h3>3. Amino Acid Complex</h3>
      <p>Enriched with 18 types of free amino acids including glycine, proline, and tryptophan that act as protein building blocks and precursors of natural plant growth hormones.</p>
      
      <h3>4. Bio Stimulant Work Mechanism</h3>
      <p>Works at the molecular level by activating genes related to stress tolerance, photosynthesis efficiency, and nutrient uptake. Increases ATP production and key enzyme activity in plant metabolism.</p>
      
      <h3>5. Field Application Results</h3>
      <p>Trials on tomato plants showed a 22% yield increase, 45% reduction in fruit cracking, and 18% increase in lycopene content. In rice plants, there was a 15% increase in productive tillers and 30% lodging resistance.</p>
      
      <h3>6. Multi-Crop Application</h3>
      <p>Effective for all types of plants: vegetables (200ml/100L water), fruits (300ml/100L water), food crops (150ml/100L water), and ornamental plants (100ml/100L water). Can be combined with organic or chemical fertilizers.</p>
      
      <p>Innovative solution for modern agriculture that desires increased productivity while maintaining the principles of sustainable and environmentally friendly agriculture.</p>
    `,
    author: "Prof. Dr. Bambang Cahyono",
    publishedDate: "2024-01-05",
    category: "Bio Stimulant",
    image: "/assets/images/biostimulan.jpg",
    tags: ["Bio Stimulant", "Seaweed Extract", "Humic Acid", "Organic Agriculture"],
    readTime: "10 minutes",
  },
];

export default blogDataEn;
